const initializedRegionForms = new WeakSet();

function initializeRegionForms() {
  document.querySelectorAll('[data-region-form]').forEach((form) => {
    if (initializedRegionForms.has(form)) return;
    const prefecture = form.querySelector('[data-region-prefecture]');
    const city = form.querySelector('[data-region-city]');
    if (!prefecture || !city) return;
    const regions = JSON.parse(form.dataset.regions);
    initializedRegionForms.add(form);

    prefecture.addEventListener('change', () => {
      city.replaceChildren(new Option('市区町村を選択', ''));
      (regions[prefecture.value] || []).forEach((name) => city.add(new Option(name, name)));
      city.value = '';
    });
  });
}

document.addEventListener('DOMContentLoaded', initializeRegionForms);
document.addEventListener('turbolinks:load', initializeRegionForms);
